import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-search\"><path d=\"M8.25 1C4.255 1 1 4.255 1 8.25s3.255 7.25 7.25 7.25a7.21 7.21 0 0 0 4.562-1.626l4.906 4.906a.752.752 0 0 0 1.062 0 .743.743 0 0 0 0-1.054l-4.906-4.906A7.217 7.217 0 0 0 15.5 8.25C15.5 4.255 12.245 1 8.25 1Zm0 1.5A5.738 5.738 0 0 1 14 8.25 5.738 5.738 0 0 1 8.25 14 5.739 5.739 0 0 1 2.5 8.25 5.738 5.738 0 0 1 8.25 2.5Z\" fill=\"currentColor\" stroke=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol